module.exports = __webpack_public_path__ + "img/mail.3986c80a.svg";